/**
 * Created by asiulik on 01.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../core/video'], function($, _, EventEmitter, YoutubeVideo){

    var config = {
        videoOverlaySelector: "#videoOverlay",
        videoOverlayTrigger: "[data-popup-yvideo-id]",
        videoOverlayTriggerAttr: "data-popup-yvideo-id",
        videoOverlayVideoContentElement: '#videoContentElement'
    };

    function OverlayVideo(overlayInstance){
        this.overlay = overlayInstance;
    }

    OverlayVideo.prototype.init = function(){

        this.$videoOverlay = $(config.videoOverlaySelector);
        this.$videoTriggerElements = $(config.videoOverlayTrigger);
        this.$videoContentElement = this.$videoOverlay.find(config.videoOverlayVideoContentElement);

        this.bindEvents();

    };

    OverlayVideo.prototype.bindEvents = function(){

        var _this = this;

        this.$videoTriggerElements.on({
            click: function(e){

                e.preventDefault();

                _this.openVideoPopup($(e.target).attr(
                    config.videoOverlayTriggerAttr
                ));
            }
        });

        this.overlay.on('hideOverlay', function(){

            if(_this.youtubeVideoInstance) {
                _this.clearVideoContainer();
            }

        });

    };

    OverlayVideo.prototype.openVideoPopup = function(videoYoutubeId){

        this.overlay.openOverlay(
            this.$videoOverlay
        );

        setTimeout(function(){
            this.youtubeVideoInstance = new YoutubeVideo(videoYoutubeId, this.$videoContentElement);
        }.bind(this), 500);

    };

    OverlayVideo.prototype.clearVideoContainer = function(){
        this.youtubeVideoInstance.clearPlayer();
    };

    return OverlayVideo;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlayVideo.js